import { render, staticRenderFns } from "./AdjustItem.vue?vue&type=template&id=6f8d30f2&scoped=true&"
import script from "./AdjustItem.vue?vue&type=script&lang=js&"
export * from "./AdjustItem.vue?vue&type=script&lang=js&"
import style0 from "./AdjustItem.vue?vue&type=style&index=0&id=6f8d30f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8d30f2",
  null
  
)

export default component.exports